export const LOGO = "/logo.png";

export const CONTACT = {
    phoneDisplay: "+41 76 238 79 47",
    phoneHref: "tel:+41762387947",
    whatsapp: "https://wa.me/41762387947?text=Ciao%20The%20Market!%20Vorrei%20prenotare%20un%20tavolo.",
    whatsappDs: "https://wa.me/41762387947?text=Ciao%20The%20Market!%20Vorrei%20prenotare%20per%20DEEP%20SOCIETY%20di%20sabato%20sera.",
    email: "themarketlugano@gmail.com",
    instagram: "https://www.instagram.com/themarket_lugano",
    maps: "https://maps.google.com/?q=The+Market+Lugano,+Via+Pasquale+Lucchini+12,+6900+Lugano",
    tripadvisor: "https://www.tripadvisor.com/Search?q=The%20Market%20Lugano",
    google: "https://www.google.com/maps/search/?api=1&query=The+Market+Lugano",
};

export const copy = {
    it: {
        nav: {
            about: "Il Locale",
            menu: "Menù",
            events: "Eventi",
            gallery: "Galleria",
            reviews: "Recensioni",
            contact: "Contatti",
            book: "Prenota",
            shop: "Shop",
        },
        hero: {
            eyebrow: "Lugano · Via Pasquale Lucchini 12",
            openNow: "Aperto ora",
            closedNow: "Chiuso ora",
            line1: "Dal pranzo",
            line2: "al dopocena.",
            line3: "Il posto che meriti.",
            tagline:
                "Bistrot, wine bar e cocktail bar nel cuore di Lugano: pranzo, aperitivo, cena e dopocena, ogni giorno.",
            ctaCall: "Prenota",
            ctaWhats: "WhatsApp",
            ctaMenu: "Scopri le carte",
            metricReviews: "recensioni Google",
            metricPrice: "a persona",
            metricWines: "vini al calice",
            scroll: "Scorri",
        },
        marquee: ["Pranzo", "Aperitivo", "Cena", "Dopocena", "Wine bar", "Lugano"],
        about: {
            label: "Il locale",
            titleA: "Più di un bar.",
            titleB: "Un luogo da vivere.",
            quote: "«Si viene volentieri a pranzo. E si resta fino all'ultimo brindisi.»",
            p1: "Siamo Barbara e Marco, una coppia con la passione di sempre per l'ospitalità, il buon cibo e il buon bere. The Market l'abbiamo pensato come il locale che ci sarebbe piaciuto trovare: curato, accogliente, senza pose. Vicino al centro di Lugano, a due passi da Parco Ciani e dal Casinò.",
            p2: "Si entra per un pranzo veloce e si finisce per restare: l'aperitivo è la vera sorpresa, poi la cena, poi l'ultimo calice. Un locale per tutti — puoi spendere poco o tanto, dipende solo da te. E per gruppi, uffici e compleanni il locale si trasforma per la vostra festa.",
            stat1: "recensioni Google",
            stat2: "prezzo medio",
            stat3: "Parco Ciani · Casinò",
        },
        moments: {
            label: "I momenti",
            title: "Il pranzo è solo l'inizio.",
            items: [
                { time: "12:00", name: { it: "Pranzo", en: "Lunch" }, desc: { it: "Insalatone, pinse e piatti caldi, veloci e curati. Smart lunch con bibita e caffè a 20.–", en: "Big salads, pinse and hot dishes, quick and cared for. Smart lunch with soft drink and coffee at 20.–" } },
                { time: "17:00", name: { it: "Aperitivo", en: "Aperitivo" }, desc: { it: "La vera sorpresa: taglieri, spritz e il banco che si anima.", en: "The real surprise: boards, spritz and a counter that comes alive." } },
                { time: "19:00", name: { it: "Cena", en: "Dinner" }, desc: { it: "Focaccine, pinse, taglieri e la Chef Beef Selection. Cucina easy, qualità seria.", en: "Focaccine, pinse, boards and the Chef Beef Selection. Easy kitchen, serious quality." } },
                { time: "22:00", name: { it: "Dopocena", en: "Late night" }, desc: { it: "Cocktail, distillati e l'ultimo calice. E quando c'è il DJ set, sempre elegante.", en: "Cocktails, spirits and one last glass. And when there's a DJ set, always elegant." } },
            ],
        },
        menu: {
            label: "Le carte",
            title: "Gusto in primo piano",
            subtitle: "Bistrot, wine bar e cocktail bar: quattro carte, un'unica anima.",
            tabs: {
                pranzo: "Pranzo",
                sera: "Sera",
                vini: "Vini",
                cocktails: "Cocktail & Spritz",
                birre: "Birre",
                spirits: "Distillati",
                analcolici: "Analcolici",
            },
            note: "Prezzi in CHF, IVA inclusa. Impasto senza glutine +2.–. Informa il personale per allergie o intolleranze.",
        },
        eventsPage: {
            label: "Serate & Eventi",
            title: "Il calendario The Market",
            nextSaturdays: "I prossimi sabati",
            saturday: "Sabato",
            dinner: "Cena dalle 19:00",
            vinyl: "Clubbing su vinili fino a tardi",
            bookCta: "Prenota",
            specialTitle: "Serate speciali",
            specialEmpty: "Le prossime serate speciali vengono annunciate su Instagram. Seguici per non perdere le date!",
            followInsta: "Seguici su Instagram",
        },
        deepSociety: {
            label: "Ogni sabato sera",
            text: "Prima la cena, poi il club. Ogni sabato The Market si accende di musica elettronica underground suonata rigorosamente su vinili — un po' Berlino, tanto Lugano.",
            chips: ["Cena", "Solo vinili", "Clubbing"],
            cta: "Prenota il tuo sabato",
        },
        events: {
            label: "Serate & eventi",
            title: "Le serate a tema",
            subtitle: "DJ set sempre eleganti, serate a tema durante l'anno — le date? Su Instagram.",
            privateTitle: "Evento privato?",
            privateText: "Gruppi, uffici, compleanni, occasioni speciali: festeggiamo un sacco di eventi privati, e il locale si trasforma per voi.",
            privateCta: "Richiedi un preventivo",
            videoTitle: "Così sono le serate The Market",
            videoText: "DJ set, aperocena e bollicine: questa è l'atmosfera che trovi quando organizziamo una serata. Le date? Su Instagram.",
        },
        gallery: { label: "Galleria", title: "Dentro The Market" },
        reviews: {
            label: "Dicono di noi",
            title: "Amato da Lugano",
            google: "recensioni su Google",
            tripadvisor: "su Tripadvisor",
            seeAll: "Leggi tutte le recensioni",
        },
        shopTeaser: {
            label: "Shop",
            title: "Porta The Market con te",
            subtitle: "T-shirt, cappellini, gift card e buoni regalo: il nostro mondo, da indossare e da regalare.",
            cta: "Scopri lo Shop",
        },
        reserve: {
            label: "Prenotazioni",
            title: "Il tuo tavolo ti aspetta",
            callTitle: "Prenota un tavolo",
            callText: "Chiamaci e troviamo il posto giusto per te — banco, tavolo o dehors.",
            callCta: "Chiama ora",
            whatsappCta: "Scrivici su WhatsApp",
            formTitle: "Evento privato o festa",
            formText: "Raccontaci la tua idea: ti rispondiamo con un preventivo entro 24 ore.",
            name: "Nome e cognome",
            email: "Email",
            phone: "Telefono (facoltativo)",
            date: "Data dell'evento",
            guests: "Numero di ospiti",
            message: "Raccontaci il tuo evento",
            submit: "Richiedi preventivo",
            sending: "Invio in corso…",
            success: "Richiesta inviata! Ti ricontatteremo al più presto.",
            error: "Qualcosa è andato storto. Riprova o chiamaci.",
        },
        footer: {
            contacts: "Contatti",
            hours: "Orari",
            days: [
                ["Lunedì", "11:00 – 16:00"],
                ["Martedì – Mercoledì", "11:00 – 23:00"],
                ["Giovedì – Venerdì", "11:00 – 24:00"],
                ["Sabato", "18:00 – 24:00"],
                ["Domenica", "Chiuso"],
            ],
            follow: "Seguici",
            rights: "Tutti i diritti riservati.",
            made: "Bistrot · Wine bar · Cocktail bar",
        },
        shop: {
            title: "Shop",
            subtitle: "Il merchandise ufficiale di The Market. Preordina online: ritira gratis al locale o ricevi a casa.",
            cats: { gift: "Gift Card & Buoni", tshirt: "T-Shirt", cap: "Cappellini", beanie: "Invernali", apron: "Grembiuli", umbrella: "Ombrelli" },
            giftCardDesc: "Valida su tutto: cena, drink e merchandise The Market.",
            aperitivoDesc: "1 Tagliere x2 · 1 Focaccina · 1 Drink a persona",
            cenaDesc: "1 Tagliere in aperitivo · 1 Bottiglia di Rosso, Bianco o Prosecco (Valpolicella, Grillo, Prosecco) · 2 Piatti a scelta dal menù",
            model: "Modello",
            size: "Taglia",
            add: "Aggiungi",
            preorder: "Preordine",
            comingSoon: "In arrivo",
            cart: "Carrello",
            empty: "Il carrello è vuoto.",
            subtotal: "Subtotale",
            delivery: "Consegna",
            pickup: "Ritiro al locale",
            pickupNote: "Gratis — ti arriva un'email quando è pronto al banco.",
            ship: "Spedizione in Svizzera",
            shipCost: "+ CHF 4.–",
            freeShip: "Gratis da CHF 100.–",
            shipNote: "L'indirizzo di spedizione ti verrà chiesto al pagamento.",
            freeShipOn: "Spedizione gratuita!",
            total: "Totale",
            name: "Nome e cognome",
            email: "Email",
            phone: "Telefono (facoltativo)",
            checkout: "Vai al pagamento",
            payNote: "Pagamento sicuro con carta o TWINT.",
            back: "Torna al sito",
            checking: "Controllo del pagamento…",
            successTitle: "Ordine confermato!",
            successText: "Pagamento ricevuto. Ti scriviamo via email appena l'articolo è pronto per il ritiro o è stato spedito.",
            cancelTitle: "Pagamento annullato",
            cancelText: "Nessun addebito effettuato. Il carrello ti aspetta.",
            backShop: "Torna allo shop",
            error: "Qualcosa è andato storto. Riprova o scrivici su WhatsApp.",
        },
    },
    en: {
        nav: {
            about: "The Place",
            menu: "Menu",
            events: "Events",
            gallery: "Gallery",
            reviews: "Reviews",
            contact: "Contact",
            book: "Book",
            shop: "Shop",
        },
        hero: {
            eyebrow: "Lugano · Via Pasquale Lucchini 12",
            openNow: "Open now",
            closedNow: "Closed now",
            line1: "From lunch",
            line2: "to late night.",
            line3: "The place you deserve.",
            tagline:
                "Bistrot, wine bar and cocktail bar in the heart of Lugano: lunch, aperitivo, dinner and after-dinner, every day.",
            ctaCall: "Book",
            ctaWhats: "WhatsApp",
            ctaMenu: "Explore the menus",
            metricReviews: "Google reviews",
            metricPrice: "per person",
            metricWines: "wines by the glass",
            scroll: "Scroll",
        },
        marquee: ["Lunch", "Aperitivo", "Dinner", "Late night", "Wine bar", "Lugano"],
        about: {
            label: "The place",
            titleA: "More than a bar.",
            titleB: "A place to live.",
            quote: "«You come gladly for lunch. And you stay until the last toast.»",
            p1: "We are Barbara and Marco, a couple with a lifelong passion for hospitality, good food and good wine. We imagined The Market as the place we would have loved to find ourselves: cared for, welcoming, no airs. Just off central Lugano, steps from Parco Ciani and the Casinò.",
            p2: "You drop in for a quick lunch and end up staying: aperitivo is the real surprise, then dinner, then one last glass. A place for everyone — spend little or a lot, it's entirely up to you. And for groups, offices and birthdays, the venue transforms for your celebration.",
            stat1: "Google reviews",
            stat2: "average price",
            stat3: "Parco Ciani · Casinò",
        },
        moments: {
            label: "The moments",
            title: "Lunch is just the beginning.",
            items: [
                { time: "12:00", name: { it: "Pranzo", en: "Lunch" }, desc: { it: "Insalatone, pinse e piatti caldi, veloci e curati. Smart lunch con bibita e caffè a 20.–", en: "Big salads, pinse and hot dishes, quick and cared for. Smart lunch with soft drink and coffee at 20.–" } },
                { time: "17:00", name: { it: "Aperitivo", en: "Aperitivo" }, desc: { it: "La vera sorpresa: taglieri, spritz e il banco che si anima.", en: "The real surprise: boards, spritz and a counter that comes alive." } },
                { time: "19:00", name: { it: "Cena", en: "Dinner" }, desc: { it: "Focaccine, pinse, taglieri e la Chef Beef Selection. Cucina easy, qualità seria.", en: "Focaccine, pinse, boards and the Chef Beef Selection. Easy kitchen, serious quality." } },
                { time: "22:00", name: { it: "Dopocena", en: "Late night" }, desc: { it: "Cocktail, distillati e l'ultimo calice. E quando c'è il DJ set, sempre elegante.", en: "Cocktails, spirits and one last glass. And when there's a DJ set, always elegant." } },
            ],
        },
        menu: {
            label: "The menus",
            title: "Taste, front and center",
            subtitle: "Bistrot, wine bar and cocktail bar: four lists, one soul.",
            tabs: {
                pranzo: "Lunch",
                sera: "Dinner",
                vini: "Wine",
                cocktails: "Cocktails & Spritz",
                birre: "Beer",
                spirits: "Spirits",
                analcolici: "Alcohol-free",
            },
            note: "Prices in CHF, VAT included. Gluten-free dough +2.–. Please inform our staff about allergies or intolerances.",
        },
        eventsPage: {
            label: "Nights & Events",
            title: "The Market Calendar",
            nextSaturdays: "Upcoming Saturdays",
            saturday: "Saturday",
            dinner: "Dinner from 7 PM",
            vinyl: "Vinyl clubbing till late",
            bookCta: "Book now",
            specialTitle: "Special nights",
            specialEmpty: "Upcoming special nights are announced on Instagram. Follow us so you don't miss the dates!",
            followInsta: "Follow us on Instagram",
        },
        deepSociety: {
            label: "Every Saturday night",
            text: "Dinner first, then the club. Every Saturday The Market lights up with underground electronic music played strictly on vinyl — a bit of Berlin, a lot of Lugano.",
            chips: ["Dinner", "Vinyl only", "Clubbing"],
            cta: "Book your Saturday",
        },
        events: {
            label: "Nights & events",
            title: "Themed nights",
            subtitle: "Always-elegant DJ sets, themed nights throughout the year — the dates? On Instagram.",
            privateTitle: "Private event?",
            privateText: "Groups, offices, birthdays, special occasions: we host loads of private events, and the venue transforms for you.",
            privateCta: "Request a quote",
            videoTitle: "This is what The Market nights feel like",
            videoText: "DJ sets, aperocena and bubbles: this is the vibe when we throw a themed night. The dates? On Instagram.",
        },
        gallery: { label: "Gallery", title: "Inside The Market" },
        reviews: {
            label: "Word of mouth",
            title: "Loved by Lugano",
            google: "reviews on Google",
            tripadvisor: "on Tripadvisor",
            seeAll: "Read all reviews",
        },
        shopTeaser: {
            label: "Shop",
            title: "Take The Market with you",
            subtitle: "T-shirts, caps, gift cards and vouchers: our world, to wear and to give.",
            cta: "Discover the Shop",
        },
        reserve: {
            label: "Reservations",
            title: "Your table is waiting",
            callTitle: "Book a table",
            callText: "Call us and we'll find the right spot for you — counter, table or terrace.",
            callCta: "Call now",
            whatsappCta: "Message us on WhatsApp",
            formTitle: "Private event or party",
            formText: "Tell us your idea: we'll reply with a tailored quote within 24 hours.",
            name: "Full name",
            email: "Email",
            phone: "Phone (optional)",
            date: "Event date",
            guests: "Number of guests",
            message: "Tell us about your event",
            submit: "Request quote",
            sending: "Sending…",
            success: "Request sent! We'll get back to you shortly.",
            error: "Something went wrong. Please retry or call us.",
        },
        footer: {
            contacts: "Contact",
            hours: "Opening hours",
            days: [
                ["Monday", "11:00 AM – 4:00 PM"],
                ["Tuesday – Wednesday", "11:00 AM – 11:00 PM"],
                ["Thursday – Friday", "11:00 AM – midnight"],
                ["Saturday", "6:00 PM – midnight"],
                ["Sunday", "Closed"],
            ],
            follow: "Follow us",
            rights: "All rights reserved.",
            made: "Bistrot · Wine bar · Cocktail bar",
        },
        shop: {
            title: "Shop",
            subtitle: "The official The Market merchandise. Pre-order online: free pickup at the venue or home delivery.",
            cats: { gift: "Gift Cards & Vouchers", tshirt: "T-Shirts", cap: "Caps", beanie: "Beanies", apron: "BBQ Aprons", umbrella: "Umbrellas" },
            giftCardDesc: "Valid on everything: dinner, drinks and The Market merch.",
            aperitivoDesc: "1 Sharing board for 2 · 1 Focaccina · 1 drink per person",
            cenaDesc: "1 Aperitif board · 1 Bottle of red, white or Prosecco (Valpolicella, Grillo, Prosecco) · 2 dishes of your choice from the menu",
            model: "Model",
            size: "Size",
            add: "Add",
            preorder: "Pre-order",
            comingSoon: "Coming soon",
            cart: "Cart",
            empty: "Your cart is empty.",
            subtotal: "Subtotal",
            delivery: "Delivery",
            pickup: "Pickup at the venue",
            pickupNote: "Free — you'll get an email when it's ready at the counter.",
            ship: "Swiss delivery",
            shipCost: "+ CHF 4.–",
            freeShip: "Free from CHF 100.–",
            shipNote: "You'll be asked for your shipping address at checkout.",
            freeShipOn: "Free shipping!",
            total: "Total",
            name: "Full name",
            email: "Email",
            phone: "Phone (optional)",
            checkout: "Go to payment",
            payNote: "Secure payment by card or TWINT.",
            back: "Back to the site",
            checking: "Checking your payment…",
            successTitle: "Order confirmed!",
            successText: "Payment received. We'll email you as soon as your item is ready for pickup or has been shipped.",
            cancelTitle: "Payment cancelled",
            cancelText: "No charge was made. Your cart is waiting for you.",
            backShop: "Back to the shop",
            error: "Something went wrong. Retry or message us on WhatsApp.",
        },
    },
    de: {
        nav: {
            about: "Das Lokal",
            menu: "Menü",
            events: "Events",
            gallery: "Galerie",
            reviews: "Bewertungen",
            contact: "Kontakt",
            book: "Reservieren",
            shop: "Shop",
        },
        hero: {
            eyebrow: "Lugano · Via Pasquale Lucchini 12",
            openNow: "Jetzt geöffnet",
            closedNow: "Jetzt geschlossen",
            line1: "Vom Mittagessen",
            line2: "bis spät in die Nacht.",
            line3: "Der Ort, den du verdienst.",
            tagline:
                "Bistrot, Weinbar und Cocktailbar im Herzen von Lugano: Mittagessen, Aperitivo, Abendessen und danach — jeden Tag.",
            ctaCall: "Reservieren",
            ctaWhats: "WhatsApp",
            ctaMenu: "Karten entdecken",
            metricReviews: "Google-Bewertungen",
            metricPrice: "pro Person",
            metricWines: "Weine offen",
            scroll: "Scrollen",
        },
        marquee: ["Mittagessen", "Aperitivo", "Abendessen", "Late Night", "Weinbar", "Lugano"],
        about: {
            label: "Das Lokal",
            titleA: "Mehr als eine Bar.",
            titleB: "Ein Ort zum Leben.",
            quote: "«Man kommt gerne zum Mittagessen. Und bleibt bis zum letzten Toast.»",
            p1: "Wir sind Barbara und Marco, ein Paar mit einer grossen Leidenschaft für Gastfreundschaft, gutes Essen und guten Wein. The Market haben wir uns als das Lokal vorgestellt, das wir selbst gerne gefunden hätten: gepflegt, einladend, ohne Allüren. Nahe dem Zentrum von Lugano, wenige Schritte vom Parco Ciani und vom Casinò.",
            p2: "Man kommt für ein schnelles Mittagessen und bleibt: der Aperitivo ist die wahre Überraschung, dann das Abendessen, dann das letzte Glas. Ein Lokal für alle — du gibst wenig oder viel aus, ganz wie du willst. Und für Gruppen, Büros und Geburtstage verwandelt sich das Lokal für eure Feier.",
            stat1: "Google-Bewertungen",
            stat2: "Durchschnittspreis",
            stat3: "Parco Ciani · Casinò",
        },
        moments: {
            label: "Die Momente",
            title: "Das Mittagessen ist erst der Anfang.",
            items: [
                { time: "12:00", name: { de: "Mittagessen" }, desc: { de: "Grosse Salate, Pinse und warme Gerichte, schnell und sorgfältig. Smart Lunch mit Getränk und Kaffee für 20.–" } },
                { time: "17:00", name: { de: "Aperitivo" }, desc: { de: "Die wahre Überraschung: Taglieri, Spritz und ein Tresen, der lebendig wird." } },
                { time: "19:00", name: { de: "Abendessen" }, desc: { de: "Focaccine, Pinse, Taglieri und die Chef Beef Selection. Easy Küche, ernste Qualität." } },
                { time: "22:00", name: { de: "Late Night" }, desc: { de: "Cocktails, Spirituosen und das letzte Glas. Und wenn DJ-Set ist, immer elegant." } },
            ],
        },
        menu: {
            label: "Die Karten",
            title: "Geschmack im Fokus",
            subtitle: "Bistrot, Weinbar und Cocktailbar: vier Karten, eine Seele.",
            tabs: {
                pranzo: "Mittagessen",
                sera: "Abendessen",
                vini: "Weine",
                cocktails: "Cocktails & Spritz",
                birre: "Biere",
                spirits: "Spirituosen",
                analcolici: "Alkoholfrei",
            },
            note: "Preise in CHF, inkl. MwSt. Glutenfreier Teig +2.–. Bitte informiere unser Team über Allergien oder Unverträglichkeiten.",
        },
        eventsPage: {
            label: "Events & Abende",
            title: "Der The-Market-Kalender",
            nextSaturdays: "Die nächsten Samstage",
            saturday: "Samstag",
            dinner: "Dinner ab 19:00",
            vinyl: "Vinyl-Clubbing bis spät",
            bookCta: "Reservieren",
            specialTitle: "Spezielle Abende",
            specialEmpty: "Die nächsten speziellen Abende werden auf Instagram angekündigt. Folge uns, um die Daten nicht zu verpassen!",
            followInsta: "Folge uns auf Instagram",
        },
        deepSociety: {
            label: "Jeden Samstagabend",
            text: "Erst das Dinner, dann der Club. Jeden Samstag erwacht The Market mit elektronischer Underground-Musik, ausschliesslich auf Vinyl gespielt — ein bisschen Berlin, viel Lugano.",
            chips: ["Dinner", "Nur Vinyl", "Clubbing"],
            cta: "Reserviere deinen Samstag",
        },
        events: {
            label: "Events & Abende",
            title: "Die Themenabende",
            subtitle: "Stets elegante DJ-Sets, Themenabende übers Jahr — die Daten? Auf Instagram.",
            privateTitle: "Private Feier?",
            privateText: "Gruppen, Büros, Geburtstage, besondere Anlässe: wir feiern viele private Events, und das Lokal verwandelt sich für euch.",
            privateCta: "Offerte anfragen",
            videoTitle: "So fühlen sich die The-Market-Abende an",
            videoText: "DJ-Sets, Aperocena und Bubbles: so ist die Stimmung bei unseren Themenabenden. Die Daten? Auf Instagram.",
        },
        gallery: { label: "Galerie", title: "Inside The Market" },
        reviews: {
            label: "Stimmen",
            title: "Geliebt von Lugano",
            google: "Bewertungen auf Google",
            tripadvisor: "auf Tripadvisor",
            seeAll: "Alle Bewertungen lesen",
        },
        shopTeaser: {
            label: "Shop",
            title: "Nimm The Market mit",
            subtitle: "T-Shirts, Caps, Geschenkkarten und Gutscheine: unsere Welt zum Anziehen und Verschenken.",
            cta: "Shop entdecken",
        },
        reserve: {
            label: "Reservationen",
            title: "Dein Tisch wartet",
            callTitle: "Tisch reservieren",
            callText: "Ruf uns an und wir finden den richtigen Platz — Tresen, Tisch oder Terrasse.",
            callCta: "Jetzt anrufen",
            whatsappCta: "Schreib uns auf WhatsApp",
            formTitle: "Private Feier oder Event",
            formText: "Erzähl uns deine Idee: wir antworten innert 24 Stunden mit einer Offerte.",
            name: "Vor- und Nachname",
            email: "E-Mail",
            phone: "Telefon (optional)",
            date: "Datum des Events",
            guests: "Anzahl Gäste",
            message: "Erzähl uns von deinem Event",
            submit: "Offerte anfragen",
            sending: "Wird gesendet…",
            success: "Anfrage gesendet! Wir melden uns bald.",
            error: "Etwas ist schiefgelaufen. Bitte versuch es erneut oder ruf uns an.",
        },
        footer: {
            contacts: "Kontakt",
            hours: "Öffnungszeiten",
            days: [
                ["Montag", "11:00 – 16:00"],
                ["Dienstag – Mittwoch", "11:00 – 23:00"],
                ["Donnerstag – Freitag", "11:00 – 24:00"],
                ["Samstag", "18:00 – 24:00"],
                ["Sonntag", "Geschlossen"],
            ],
            follow: "Folge uns",
            rights: "Alle Rechte vorbehalten.",
            made: "Bistrot · Weinbar · Cocktailbar",
        },
        shop: {
            title: "Shop",
            subtitle: "Das offizielle The-Market-Merchandise. Online vorbestellen: gratis abholen oder nach Hause liefern lassen.",
            cats: { gift: "Geschenkkarten & Gutscheine", tshirt: "T-Shirts", cap: "Caps", beanie: "Mützen", apron: "Grillschürzen", umbrella: "Regenschirme" },
            giftCardDesc: "Gültig für alles: Abendessen, Drinks und The-Market-Merch.",
            aperitivoDesc: "1 Tagliere für 2 · 1 Focaccina · 1 Drink pro Person",
            cenaDesc: "1 Aperitif-Platte · 1 Flasche Rotwein, Weisswein oder Prosecco (Valpolicella, Grillo, Prosecco) · 2 Gerichte nach Wahl von der Karte",
            model: "Modell",
            size: "Grösse",
            add: "Hinzufügen",
            preorder: "Vorbestellung",
            comingSoon: "Bald verfügbar",
            cart: "Warenkorb",
            empty: "Dein Warenkorb ist leer.",
            subtotal: "Zwischensumme",
            delivery: "Lieferung",
            pickup: "Abholung im Lokal",
            pickupNote: "Gratis — du bekommst eine E-Mail, sobald es am Tresen bereitliegt.",
            ship: "Versand in der Schweiz",
            shipCost: "+ CHF 4.–",
            freeShip: "Gratis ab CHF 100.–",
            shipNote: "Die Lieferadresse wird beim Bezahlen abgefragt.",
            freeShipOn: "Gratisversand!",
            total: "Total",
            name: "Vor- und Nachname",
            email: "E-Mail",
            phone: "Telefon (optional)",
            checkout: "Zur Zahlung",
            payNote: "Sichere Zahlung mit Karte oder TWINT.",
            back: "Zurück zur Seite",
            checking: "Zahlung wird geprüft…",
            successTitle: "Bestellung bestätigt!",
            successText: "Zahlung erhalten. Wir schreiben dir per E-Mail, sobald der Artikel zur Abholung bereitliegt oder verschickt wurde.",
            cancelTitle: "Zahlung abgebrochen",
            cancelText: "Es wurde nichts abgebucht. Dein Warenkorb wartet auf dich.",
            backShop: "Zurück zum Shop",
            error: "Etwas ist schiefgelaufen. Versuch es erneut oder schreib uns auf WhatsApp.",
        },
    },
    fr: {
        nav: {
            about: "Le lieu",
            menu: "Menu",
            events: "Événements",
            gallery: "Galerie",
            reviews: "Avis",
            contact: "Contact",
            book: "Réserver",
            shop: "Shop",
        },
        hero: {
            eyebrow: "Lugano · Via Pasquale Lucchini 12",
            openNow: "Ouvert",
            closedNow: "Fermé",
            line1: "Du déjeuner",
            line2: "jusqu'à tard.",
            line3: "L'endroit que tu mérites.",
            tagline:
                "Bistrot, bar à vins et bar à cocktails au cœur de Lugano : déjeuner, apéro, dîner et after, tous les jours.",
            ctaCall: "Réserver",
            ctaWhats: "WhatsApp",
            ctaMenu: "Découvrir les cartes",
            metricReviews: "avis Google",
            metricPrice: "par personne",
            metricWines: "vins au verre",
            scroll: "Défiler",
        },
        marquee: ["Déjeuner", "Apéro", "Dîner", "After", "Bar à vins", "Lugano"],
        about: {
            label: "Le lieu",
            titleA: "Plus qu'un bar.",
            titleB: "Un lieu à vivre.",
            quote: "«On vient volontiers déjeuner. Et on reste jusqu'au dernier toast.»",
            p1: "Nous sommes Barbara et Marco, un couple passionné depuis toujours par l'hospitalité, la bonne cuisine et le bon vin. The Market, nous l'avons imaginé comme le lieu que nous aurions aimé trouver : soigné, accueillant, sans chichis. Tout près du centre de Lugano, à deux pas du Parco Ciani et du Casinò.",
            p2: "On entre pour un déjeuner rapide et on finit par rester : l'apéro est la vraie surprise, puis le dîner, puis le dernier verre. Un lieu pour tous — tu dépenses peu ou beaucoup, à toi de choisir. Et pour les groupes, les entreprises et les anniversaires, le lieu se transforme pour votre fête.",
            stat1: "avis Google",
            stat2: "prix moyen",
            stat3: "Parco Ciani · Casinò",
        },
        moments: {
            label: "Les moments",
            title: "Le déjeuner n'est que le début.",
            items: [
                { time: "12:00", name: { fr: "Déjeuner" }, desc: { fr: "Grosses salades, pinse et plats chauds, rapides et soignés. Smart lunch avec boisson et café à 20.–" } },
                { time: "17:00", name: { fr: "Apéro" }, desc: { fr: "La vraie surprise : taglieri, spritz et un comptoir qui s'anime." } },
                { time: "19:00", name: { fr: "Dîner" }, desc: { fr: "Focaccine, pinse, taglieri et la Chef Beef Selection. Cuisine easy, qualité sérieuse." } },
                { time: "22:00", name: { fr: "After" }, desc: { fr: "Cocktails, spiritueux et le dernier verre. Et quand il y a DJ set, toujours élégant." } },
            ],
        },
        menu: {
            label: "Les cartes",
            title: "Le goût d'abord",
            subtitle: "Bistrot, bar à vins et bar à cocktails : quatre cartes, une seule âme.",
            tabs: {
                pranzo: "Déjeuner",
                sera: "Dîner",
                vini: "Vins",
                cocktails: "Cocktails & Spritz",
                birre: "Bières",
                spirits: "Spiritueux",
                analcolici: "Sans alcool",
            },
            note: "Prix en CHF, TVA incluse. Pâte sans gluten +2.–. Informe notre équipe en cas d'allergies ou d'intolérances.",
        },
        eventsPage: {
            label: "Soirées & Événements",
            title: "Le calendrier The Market",
            nextSaturdays: "Les prochains samedis",
            saturday: "Samedi",
            dinner: "Dîner dès 19h00",
            vinyl: "Clubbing sur vinyle jusqu'à tard",
            bookCta: "Réserver",
            specialTitle: "Soirées spéciales",
            specialEmpty: "Les prochaines soirées spéciales sont annoncées sur Instagram. Suis-nous pour ne pas rater les dates !",
            followInsta: "Suis-nous sur Instagram",
        },
        deepSociety: {
            label: "Tous les samedis soirs",
            text: "D'abord le dîner, puis le club. Chaque samedi, The Market s'illumine au son de l'électro underground, jouée exclusivement sur vinyle — un peu Berlin, beaucoup Lugano.",
            chips: ["Dîner", "Vinyles uniquement", "Clubbing"],
            cta: "Réserve ton samedi",
        },
        events: {
            label: "Soirées & événements",
            title: "Les soirées à thème",
            subtitle: "DJ sets toujours élégants, soirées à thème toute l'année — les dates ? Sur Instagram.",
            privateTitle: "Événement privé ?",
            privateText: "Groupes, entreprises, anniversaires, occasions spéciales : nous organisons de nombreux événements privés, et le lieu se transforme pour vous.",
            privateCta: "Demander un devis",
            videoTitle: "Voilà l'ambiance des soirées The Market",
            videoText: "DJ sets, aperocena et bulles : voici l'ambiance de nos soirées à thème. Les dates ? Sur Instagram.",
        },
        gallery: { label: "Galerie", title: "Inside The Market" },
        reviews: {
            label: "Ils parlent de nous",
            title: "Adoré par Lugano",
            google: "avis sur Google",
            tripadvisor: "sur Tripadvisor",
            seeAll: "Lire tous les avis",
        },
        shopTeaser: {
            label: "Boutique",
            title: "Emportez The Market avec vous",
            subtitle: "T-shirts, casquettes, cartes et bons cadeaux : notre univers, à porter et à offrir.",
            cta: "Découvrir la boutique",
        },
        reserve: {
            label: "Réservations",
            title: "Ta table t'attend",
            callTitle: "Réserver une table",
            callText: "Appelle-nous et on te trouve la bonne place — comptoir, table ou terrasse.",
            callCta: "Appeler",
            whatsappCta: "Écris-nous sur WhatsApp",
            formTitle: "Événement privé ou fête",
            formText: "Raconte-nous ton idée : on te répond avec un devis sous 24 h.",
            name: "Nom et prénom",
            email: "E-mail",
            phone: "Téléphone (facultatif)",
            date: "Date de l'événement",
            guests: "Nombre d'invités",
            message: "Raconte-nous ton événement",
            submit: "Demander un devis",
            sending: "Envoi…",
            success: "Demande envoyée ! On te recontacte très vite.",
            error: "Quelque chose n'a pas marché. Réessaie ou appelle-nous.",
        },
        footer: {
            contacts: "Contact",
            hours: "Horaires",
            days: [
                ["Lundi", "11h00 – 16h00"],
                ["Mardi – Mercredi", "11h00 – 23h00"],
                ["Jeudi – Vendredi", "11h00 – minuit"],
                ["Samedi", "18h00 – minuit"],
                ["Dimanche", "Fermé"],
            ],
            follow: "Suis-nous",
            rights: "Tous droits réservés.",
            made: "Bistrot · Bar à vins · Bar à cocktails",
        },
        shop: {
            title: "Shop",
            subtitle: "Le merchandise officiel de The Market. Précommande en ligne : retrait gratuit au bar ou livraison à domicile.",
            cats: { gift: "Cartes & Bons cadeaux", tshirt: "T-Shirts", cap: "Casquettes", beanie: "Bonnets", apron: "Tabliers BBQ", umbrella: "Parapluies" },
            giftCardDesc: "Valable sur tout : dîner, boissons et merch The Market.",
            aperitivoDesc: "1 Planche pour 2 · 1 Focaccina · 1 boisson par personne",
            cenaDesc: "1 Planche en apéritif · 1 Bouteille de rouge, blanc ou Prosecco (Valpolicella, Grillo, Prosecco) · 2 plats au choix du menu",
            model: "Modèle",
            size: "Taille",
            add: "Ajouter",
            preorder: "Précommande",
            comingSoon: "Bientôt disponible",
            cart: "Panier",
            empty: "Ton panier est vide.",
            subtotal: "Sous-total",
            delivery: "Livraison",
            pickup: "Retrait au bar",
            pickupNote: "Gratuit — tu reçois un e-mail quand c'est prêt au comptoir.",
            ship: "Livraison en Suisse",
            shipCost: "+ CHF 4.–",
            freeShip: "Gratuit dès CHF 100.–",
            shipNote: "L'adresse de livraison te sera demandée au paiement.",
            freeShipOn: "Livraison gratuite !",
            total: "Total",
            name: "Nom et prénom",
            email: "E-mail",
            phone: "Téléphone (facultatif)",
            checkout: "Passer au paiement",
            payNote: "Paiement sécurisé par carte ou TWINT.",
            back: "Retour au site",
            checking: "Vérification du paiement…",
            successTitle: "Commande confirmée !",
            successText: "Paiement reçu. On t'écrit par e-mail dès que l'article est prêt au retrait ou expédié.",
            cancelTitle: "Paiement annulé",
            cancelText: "Aucun débit. Ton panier t'attend.",
            backShop: "Retour au shop",
            error: "Quelque chose n'a pas marché. Réessaie ou écris-nous sur WhatsApp.",
        },
    },
};

export const menuData = {
    pranzo: {
        intro: {
            it: "Richiedi la tua Fidelity Card — ogni 10 pasti, l'11° te lo offriamo noi.",
            en: "Ask for your Fidelity Card — every 10 meals, the 11th is on us.",
            de: "Frag nach deiner Fidelity Card — alle 10 Essen geht das 11. auf uns.",
            fr: "Demandez votre carte de fidélité — tous les 10 repas, le 11e est offert.",
        },
        groups: [
            {
                group: { it: "Insalatone", en: "Big Salads" },
                items: [
                    { name: "SALMO", desc: "Insalata mista, pomodorini, salmone affumicato, avocado, olio, sale Maldon, pepe", price: 20 },
                    { name: "PINNA GIALLA", desc: "Insalata mista, pomodorini, tonno, olive taggiasche, mozzarella di bufala, olio, sale Maldon, pepe", price: 20 },
                    { name: "OSTUNI", desc: "Insalata mista, pomodorini, burrata e acciughe del Cantabrico", price: 20 },
                    { name: "MEDITERRANEA", desc: "Quinoa rossa, carote, mais, ceci, burrata e avocado · +tonno 3.–", price: 20 },
                    { name: "SPENCER", desc: "Farro, fagioli, piselli, olive, pomodorini, tonno e pomodorini semi-dry", price: 20 },
                    { name: "CAPRESE DI BUFALA", desc: "Pomodorini cherry, mozzarella di bufala, rucola, olio EVO, sale Maldon, pepe e origano · +crudo 3.–", price: 18 },
                ],
            },
            {
                group: { it: "Pinse & Schiacciate", en: "Pinse & Schiacciate" },
                note: { it: "Pinsa 250 g 19.– · Schiacciata 150 g 14.– · Impasto senza glutine +2.–", en: "Pinsa 250 g 19.– · Schiacciata 150 g 14.– · Gluten-free dough +2.–" },
                items: [
                    { name: "CHE MANZA", desc: "Tartare di manzo, olio, sale Maldon, pepe e origano" },
                    { name: "MORTAZZA", desc: "Mortadella, burrata e granella di pistacchi" },
                    { name: "BUFALA", desc: "Crudo, mozzarella di bufala, rucola, pomodorini" },
                    { name: "BURRATINA", desc: "Salsa di pomodoro, burrata, pomodorini e pesto di basilico" },
                    { name: "CANTABRIA", desc: "Salsa di pomodoro, burrata, aglio, olive taggiasche e acciughe del Cantabrico" },
                    { name: "PEPENERO", desc: "Roastbeef, olio, sale Maldon, pepe, salsa tartara, rucola e grana" },
                    { name: "ENERGY", desc: "Mozzarella in cottura, bresaola, rucola, grana, olio EVO, pepe e limone" },
                    { name: "PORCA", desc: "Mozzarella in cottura, gorgonzola, lardo di Pata Negra, miele, noci" },
                ],
            },
            {
                group: { it: "Smart Lunch", en: "Smart Lunch" },
                items: [
                    { name: "PINSA SMALL + BIBITA + CAFFÈ", desc: "Pinsa 150 g, bibita e caffè — la pausa pranzo veloce", price: 20 },
                ],
            },
            {
                group: { it: "Piatti Caldi", en: "Hot Dishes" },
                items: [
                    { name: "TORTELLINI", desc: "Con panna e prosciutto", price: 18 },
                    { name: "GARGANELLI AL SALMONE", desc: "Con panna e granella di pistacchio", price: 18 },
                    { name: "STROZZAPRETI", desc: "Con speck e funghi", price: 18 },
                    { name: "PARMIGIANA DI MELANZANE", price: 18 },
                    { name: "POLPETTE AL SUGO", desc: "Con piselli", price: 24 },
                ],
            },
            {
                group: { it: "Leggeri & Freschi", en: "Light & Fresh" },
                items: [
                    { name: "VITELLO TONNATO DELLA CASA", desc: "Salsa tonnata, capperi, rucola e confettura di cipolla rossa", price: 24 },
                    { name: "TARTARE DI MANZO 140 g", desc: "Olio EVO, sale Maldon, pepe, pomodorini confit semi-dry e basilico", price: 25 },
                    { name: "CARPACCIO DI CARNE SALADA 140 g", desc: "Insalata, sale Maldon, pepe, olio EVO, olive taggiasche e grana", price: 25 },
                    { name: "ROASTBEEF 140 g", desc: "Rucola, sale Maldon, pepe, olio EVO, grana e salsa tartara", price: 25 },
                    { name: "BRESAOLA PUNTA D'ANCA 100 g", desc: "Rucola, scaglie di Grana Padano, olio EVO, pepe e limone", price: 23 },
                    { name: "CRUDO E BUFALA 100 g", desc: "Crudo San Pietro (TI), mozzarella di bufala Campana e basilico", price: 23 },
                ],
            },
        ],
    },
    sera: {
        intro: null,
        video: "social",
        groups: [
            {
                group: { it: "Antipasti", en: "Starters" },
                items: [
                    { name: "ACCIUGHE DEL CANTABRICO", desc: "Con focaccina calda e burro del Gottardo", price: 23 },
                    { name: "IL PIATTINO", desc: "Piattino di salumi a scelta (100 g) con focaccina all'origano", price: 20 },
                    { name: "PATA NEGRA PAN Y TOMATO", price: 42 },
                    { name: "POLENTINA CON LARDO DI PATA NEGRA", price: 18 },
                    { name: "POLENTINA CON GORGONZOLA", price: 18 },
                    { name: "EMPANADA — MANZO / POLLO / SPINACI", price: 7 },
                    { name: "TRIS EMPANADAS", price: 18 },
                ],
            },
            {
                group: { it: "Focaccine", en: "Focaccine" },
                items: [
                    { name: "MANZO CRIMINALE", desc: "Tartare, burrata, datterino semi dry, basilico", price: 21 },
                    { name: "PORCO BELLO", desc: "Lardo di Pata Negra, miele, noci e zest di lime", price: 21 },
                    { name: "VIVO E VEGET-ALE", desc: "Burrata, olive taggiasche, datterino semi dry, basilico", price: 21 },
                    { name: "ROAST IN PEACE", desc: "Roastbeef, rucola, grana e salsa tartara", price: 21 },
                    { name: "ANDATO E TONNATO", desc: "Vitello, salsa tonnata, rucola, confettura di cipolla rossa", price: 21 },
                ],
            },
            {
                group: { it: "Taglieri", en: "Boards" },
                note: { it: "Ideali per 2 persone — to share", en: "Ideal for 2 — to share" },
                items: [
                    { name: "TAGLIERE DI FORMAGGI", price: 35 },
                    { name: "TAGLIERE DI SALUMI", price: 35 },
                    { name: "TAGLIERE MISTO", price: 40 },
                    { name: "TAGLIERE THE MARKET", desc: { it: "Il nostro tagliere XXL — ideale per gruppi da 6/8 persone", en: "Our XXL board — ideal for groups of 6/8" }, price: 80, tag: "XXL" },
                ],
            },
            {
                group: { it: "Chef Beef Selection", en: "Chef Beef Selection" },
                note: { it: "Ideale per 2 persone", en: "Ideal for 2" },
                items: [
                    { name: "CHEF BEEF SELECTION", desc: { it: "70 g tartare di manzo CH · 70 g bresaola punta d'anca · 70 g carpaccio di carne salada del Trentino · 70 g roastbeef CH", en: "70 g beef tartare CH · 70 g bresaola punta d'anca · 70 g Trentino carne salada carpaccio · 70 g roastbeef CH" }, price: 70, tag: "Signature" },
                ],
            },
            {
                group: { it: "Pinse", en: "Pinse" },
                note: { it: "Impasto senza glutine +2.–", en: "Gluten-free dough +2.–" },
                items: [
                    { name: "CHE MANZA!", desc: "Tartare di manzo, olio EVO, sale Maldon, origano", price: 25 },
                    { name: "MORTAZZA", desc: "Mortadella, stracciatella e granella di pistacchi", price: 25 },
                    { name: "BURRATINA", desc: "Salsa di pomodoro, burrata, pomodorini e pesto", price: 25 },
                    { name: "BUFALA", desc: "Crudo, bufala a freddo, rucola e pomodorini", price: 25 },
                    { name: "LA PORCA", desc: "Mozzarella in cottura, gorgonzola, lardo di Colonnata, miele e noci", price: 25 },
                    { name: "CANTABRIA", desc: "Salsa di pomodoro, aglio, acciughe del Cantabrico e burrata", price: 25 },
                    { name: "MAKE MARGHERITA GREAT AGAIN", desc: "Salsa di pomodoro, origano, burrata, pomodorino semi dry e basilico", price: 25 },
                ],
            },
            {
                group: { it: "Primi", en: "First Courses" },
                items: [
                    { name: "TORTELLINI", desc: "Panna e prosciutto", price: 20 },
                    { name: "PARMIGIANA DI MELANZANE", price: 20 },
                    { name: "GARGANELLI", desc: "Panna e salmone", price: 20 },
                    { name: "STROZZAPRETI", desc: "Speck e funghi", price: 20 },
                ],
            },
            {
                group: { it: "Secondi", en: "Main Courses" },
                items: [
                    { name: "POLPETTE", desc: "Polpettine al sugo e piselli", price: 28 },
                    { name: "CARPACCIO DI CARNE SALADA 140 g", desc: "Misticanza, olive taggiasche e scaglie di grana", price: 30 },
                    { name: "ROASTBEEF 100 g", desc: "Rucola, grana, olio, limone e salsa tartara", price: 30 },
                    { name: "VITELLO TONNATO", desc: "Capperi, rucola e confettura di cipolla rossa", price: 30, tag: "Recommended" },
                    { name: "TARTARE DI MANZO 140 g", desc: "Olio, sale Maldon, pepe, datterino semi dry e basilico", price: 30 },
                ],
            },
        ],
    },
    vini: {
        intro: {
            it: "Oltre 50 etichette al calice grazie al sistema Coravin — dal Merlot ticinese al Barolo, fino allo Champagne.",
            en: "Over 50 labels by the glass thanks to the Coravin system — from Ticino Merlot to Barolo, all the way to Champagne.",
            de: "Über 50 Etiketten im Glas dank des Coravin-Systems — vom Tessiner Merlot über Barolo bis hin zum Champagner.",
            fr: "Plus de 50 étiquettes au verre grâce au système Coravin — du Merlot tessinois au Barolo, jusqu'au Champagne.",
        },
        video: "coravin",
        groups: [
            {
                group: { it: "Ticino & Svizzera", en: "Ticino & Switzerland" },
                note: { it: "Calice 1 dl / Bottiglia", en: "Glass 1 dl / Bottle" },
                items: [
                    { name: "MERLOT SIRIO", desc: "Matasci", price: "13 / 70" },
                    { name: "GENGIS TICINO DOC", desc: "Merlot, Petit Verdot, Cabernet Franc — Matasci", price: "9 / 52" },
                    { name: "CHARDONNAY VENUS", desc: "Ticino DOC — Matasci", price: "13 / 70" },
                    { name: "SALOMÈ TICINO DOC", desc: "Chardonnay e Sauvignon Blanc — Matasci", price: "9 / 52" },
                    { name: "SASSI GROSSI", desc: "Bianco Ticino DOC — Gialdi", price: "13 / 70" },
                ],
            },
            {
                group: { it: "Rossi d'Italia", en: "Italian Reds" },
                note: { it: "Calice 1 dl / Bottiglia", en: "Glass 1 dl / Bottle" },
                items: [
                    { name: "LAGREIN", desc: "Ritterhof", price: "10 / 58" },
                    { name: "VALPOLICELLA CLASSICO SUPERIORE RAFAEL", desc: "Tommasi", price: "9 / 52" },
                    { name: "AMARONE DELLA VALPOLICELLA CLASSICO", desc: "Tommasi", price: "18 / 110" },
                    { name: "BARBERA BRICCO DELL'UCCELLONE", desc: "Braida", price: "20 / 140" },
                    { name: "BARBARESCO", desc: "Cantina Rizzi", price: "15 / 85" },
                    { name: "BAROLO", desc: "Giovanni Rosso", price: "18 / 110" },
                    { name: "LANGHE NEBBIOLO", desc: "Giovanni Rosso", price: "9 / 52" },
                    { name: "SFURZAT 5 STELLE", desc: "Nino Negri", price: "20 / 140" },
                    { name: "MONTEPULCIANO D'ABRUZZO MARINA CVETIC", desc: "Masciarelli", price: "13 / 70" },
                    { name: "LE VOLTE TOSCANA IGT", desc: "Ornellaia", price: "12 / 62" },
                    { name: "TESTAMATTA SANGIOVESE", desc: "Bibi Graetz", price: "20 / 140" },
                    { name: "BOLGHERI", desc: "Michele Satta", price: "12 / 62" },
                    { name: "HEBO SUVERETO DOCG", desc: "Petra", price: "9 / 52" },
                    { name: "SHIRAZ LAZIO IGT", desc: "Casale del Giglio", price: "10 / 58" },
                    { name: "PRIMITIVO DI MANDURIA GHENOS", desc: "Torrevento", price: "9 / 52" },
                    { name: "NERO D'AVOLA SHERAZADE", desc: "Donnafugata", price: "9 / 52" },
                ],
            },
            {
                group: { it: "Bianchi d'Italia", en: "Italian Whites" },
                note: { it: "Calice 1 dl / Bottiglia", en: "Glass 1 dl / Bottle" },
                items: [
                    { name: "MÜLLER THURGAU ALMA", desc: "Maso Martis", price: "13 / 70" },
                    { name: "GEWÜRZTRAMINER", desc: "Ritterhof", price: "9 / 52" },
                    { name: "CHARDONNAY BRIGATA LANGHE", desc: "Cantina Ratti", price: "8 / 48" },
                    { name: "TIMORASSO LA ZERBA", desc: "Colli Tortonesi DOC — Cantine Volpi", price: "10 / 54" },
                    { name: "ROERO ARNEIS", desc: "Giovanni Rosso", price: "12 / 62" },
                    { name: "VERMENTINO CASAMATTA", desc: "Toscana IGT — Bibi Graetz", price: "12 / 62" },
                    { name: "PIGATO", desc: "Riviera Ligure di Ponente — Lunae", price: "13 / 70" },
                    { name: "FRIULANO LA VILA", desc: "Lis Neris", price: "14 / 80" },
                    { name: "FALANGHINA ROCCALEONI", desc: "Campania IGP — Villa Matilde", price: "8 / 48" },
                ],
            },
            {
                group: { it: "Rosati", en: "Rosé" },
                note: { it: "Calice 1 dl / Bottiglia", en: "Glass 1 dl / Bottle" },
                items: [
                    { name: "LUMERA SICILIA ROSATO DOC", desc: "Donnafugata", price: "8 / 48" },
                    { name: "D&G ROSA SICILIA DOC", desc: "Nerello Mascalese — Donnafugata", price: "14 / 80" },
                    { name: "LE FORNACI ROSÈ", desc: "Turbiana e Corvina — Tommasi", price: "8 / 48" },
                ],
            },
            {
                group: { it: "Francia", en: "France" },
                note: { it: "Calice 1 dl / Bottiglia", en: "Glass 1 dl / Bottle" },
                items: [
                    { name: "BOURGOGNE PINOT NOIR LAFORÊT", desc: "Joseph Drouhin", price: "12 / 62" },
                    { name: "L'ABEILLE DE FIEUZAL PESSAC-LÉOGNAN", desc: "Bordeaux", price: "14 / 80" },
                    { name: "ECHO DE LYNCH-BAGES PAUILLAC", desc: "Bordeaux", price: "18 / 110" },
                    { name: "POUILLY-FUMÉ", desc: "Sauvignon Blanc — Baron de Ladoucette", price: "14 / 80" },
                    { name: "CHABLIS RÉSERVE DE VAUDON", desc: "Joseph Drouhin", price: "13 / 70" },
                    { name: "CHARDONNAY DE BOURGOGNE LAFORÊT BLANC", desc: "Joseph Drouhin", price: "10 / 54" },
                    { name: "M DE MINUTY PROVENCE", desc: "Château Minuty", price: "10 / 54" },
                    { name: "SANCERRE ROSÉ", desc: "100% Pinot Noir — Benoît Chauveau", price: "12 / 62" },
                ],
            },
            {
                group: { it: "Bollicine Italiane al Calice", en: "Italian Bubbles by the Glass" },
                note: { it: "Calice 1 dl / Bottiglia", en: "Glass 1 dl / Bottle" },
                items: [
                    { name: "PROSECCO SUPERIORE DOCG COL DE MEZ", desc: "Extra Dry — Soligo", price: "8 / 48" },
                    { name: "FRANCIACORTA DOCG BRUT", desc: "Bellavista", price: "12 / 80" },
                    { name: "FRANCIACORTA DOCG BRUT ROSÉ", desc: "Le Cantorie", price: "12 / 80" },
                ],
            },
            {
                group: { it: "Champagne & Trento DOC", en: "Champagne & Trento DOC" },
                note: { it: "Bottiglia 0,75 l — Palmer La Réserve anche al calice 15.–", en: "Bottle 0.75 l — Palmer La Réserve also by the glass 15.–" },
                items: [
                    { name: "PALMER LA RÉSERVE BRUT", price: 90 },
                    { name: "BOLLINGER SPECIAL CUVÉE BRUT", price: 120 },
                    { name: "LAURENT-PERRIER LA CUVÉE BRUT", price: 105 },
                    { name: "PERRIER-JOUËT GRAND BRUT", price: 110 },
                    { name: "LOUIS ROEDERER BRUT COLLECTION", price: 120 },
                    { name: "DIDIER-DUCOS NOIR ABSOLU BRUT", price: 120 },
                    { name: "RUINART BLANC DE BLANCS", desc: "100% Chardonnay", price: 180 },
                    { name: "PALMER BLANC DE BLANCS", price: 140 },
                    { name: "PALMER BLANC DE NOIRS", price: 140 },
                    { name: "RUINART ROSÉ BRUT", price: 180 },
                    { name: "PALMER ROSÉ SOLERA", price: 120 },
                    { name: "LOUIS ROEDERER ROSÉ VINTAGE", price: 180 },
                    { name: "GIULIO FERRARI RISERVA DEL FONDATORE", desc: "Trento DOC millesimata", price: 245 },
                    { name: "MASO MARTIS MILLESIMATO ROSÉ", desc: "Trento DOC — 100% Pinot Noir", price: 110 },
                    { name: "MASO MARTIS DOSAGGIO ZERO RISERVA", desc: "Trento DOC", price: 110 },
                    { name: "MADAME MARTIS DOSAGGIO ZERO RISERVA", desc: "Trento DOC", price: 310 },
                ],
            },
            {
                group: { it: "Vermouth", en: "Vermouth" },
                note: { it: "6 cl", en: "6 cl" },
                items: [
                    { name: "ROSSO ANTICO", desc: "Distilleria Jean Buton — Emilia Romagna", price: 8 },
                    { name: "RISERVA RUBINO", desc: "Martini & Rossi — Torino", price: 6 },
                    { name: "COCCHI STORICO", desc: "Giulio Cocchi — Asti", price: 7 },
                    { name: "PUNT E MES", desc: "Fratelli Branca — Torino", price: 6 },
                    { name: "CARLO ALBERTO RISERVA", desc: "Rosso o Bianco — Compagnia dei Vermouth, Piemonte", price: 10 },
                    { name: "INFERNO 9", desc: "Rosso di Dante Inga — Piemonte", price: 8 },
                    { name: "BOTTEGA CINZANO 1754", desc: "Cinzano — Torino", price: 6 },
                    { name: "DORAGROSSA", desc: "Torino", price: 7 },
                    { name: "CARPANO CLASSICO ROSSO", desc: "Fratelli Branca — Torino", price: 6 },
                    { name: "DEL PROFESSORE ROSSO", desc: "Antica Distilleria Quaglia — Piemonte", price: 10 },
                    { name: "ANTICA FORMULA", desc: "Carpano — Torino", price: 9 },
                ],
            },
            {
                group: { it: "L'Ultimo Ballo", en: "One for the Road" },
                note: { it: "Calice 0,4 dl", en: "Glass 0.4 dl" },
                items: [
                    { name: "PASSITO DI PANTELLERIA BEN RYÉ", desc: "Donnafugata", price: 9 },
                    { name: "PORTO SIX GRAPES", desc: "Graham's Reserve", price: 8 },
                ],
            },
        ],
    },
    cocktails: {
        intro: null,
        video: "social",
        groups: [
            {
                group: { it: "I Nostri Cocktail", en: "Our Cocktails" },
                items: [
                    { name: "NEGRONI THE MARKET", desc: { it: "Piangerai 3 volte: quando lo ordini, mentre lo bevi e quando lo paghi", en: "You'll cry 3 times: when you order it, while you drink it, when you pay for it" }, price: 17, tag: "Signature" },
                    { name: "NEGRONI DEL MARINAIO", desc: "Bitter Fusetti · Vermouth Carpano · Mezcal Le Tribute · Kahlua", price: 17 },
                    { name: "CASTRO STREET", desc: "Bitter Fusetti · Martini Rubino · liquore al carciofo · sale · cetriolo · oliva", price: 15 },
                    { name: "EL CHAPO", desc: "Campari · Vermouth Carpano · Tequila Patron Silver", price: 17 },
                    { name: "BOULEVARDIER", desc: "Campari · Vermouth Carpano · Bulleit Bourbon · Angostura", price: 17 },
                    { name: "NEGRONI", desc: "Campari · Vermouth Carpano Rosso · Tanqueray", price: 14 },
                    { name: "AMERICANO", desc: "Campari · Vermouth Carpano Classico · seltz", price: 13 },
                    { name: "MI-TO", desc: "Campari · Vermouth Punt e Mes", price: 13 },
                    { name: "CAMPARI ORANGE", desc: "Campari · spremuta d'arancia", price: 13 },
                    { name: "VIOLETTA SOUR", desc: "Tanqueray · liquore alla violetta · lime", price: 16 },
                    { name: "BASIL SMASH", desc: "Tanqueray · basilico fresco · limone", price: 15 },
                    { name: "WHISKEY SOUR", desc: "Bulleit Bourbon · limone", price: 16 },
                    { name: "AMARETTO SOUR", desc: "Amaretto Disaronno · limone", price: 15 },
                    { name: "PISCO SOUR", desc: "Pisco · lime", price: 16 },
                    { name: "OLD FASHIONED", desc: "Bourbon · zucchero · Angostura", price: 16 },
                    { name: "GIN FIZZ", desc: "Tanqueray · limone · seltz", price: 15 },
                    { name: "WHITE LADY", desc: "Tanqueray · triple sec · limone", price: 15 },
                    { name: "DAIQUIRI", desc: "Rum · lime", price: 15 },
                    { name: "LONG ISLAND ICED TEA", desc: "Vodka · rum · tequila · triple sec · gin · Coca-Cola", price: 15 },
                    { name: "TOMMY'S MARGARITA", desc: "Tequila Silver · agave · triple sec · lime · sale", price: 15 },
                    { name: "SPRING PALOMA", desc: "Tequila Reposado · St. Germain · soda al pompelmo · lime · sale", price: 15 },
                    { name: "ESPRESSO MARIA", desc: "Tequila Reposado · espresso · liquore al caffè", price: 16 },
                    { name: "MOSCOW MULE", desc: "Vodka · ginger beer · lime", price: 15 },
                    { name: "BLOODY MARY", desc: "Vodka · pomodoro · Worcester · Tabasco", price: 15 },
                    { name: "BLOODY FRIDA", desc: { it: "La versione con tequila — provala e poi ci dici", en: "The tequila version — try it and tell us" } },
                    { name: "ESPRESSO MARTINI", desc: "Vodka · espresso · liquore al caffè", price: 15 },
                ],
            },
            {
                group: { it: "Spritz", en: "Spritz" },
                items: [
                    { name: "BARBIE SPRITZ", desc: "Sarti Rosa · prosecco · seltz · lime", price: 10 },
                    { name: "SELECT SPRITZ", desc: "Select · prosecco · seltz · oliva verde", price: 10 },
                    { name: "GREEN SPRITZ", desc: "P31 Bitter · prosecco · seltz · limone", price: 10 },
                    { name: "HUGO SPRITZ", desc: "Prosecco · sambuco · seltz · lime · menta", price: 10 },
                    { name: "APEROL SPRITZ", desc: "Aperol · prosecco · seltz · arancia", price: 10 },
                    { name: "CAMPARI SPRITZ", desc: "Campari · prosecco · seltz · lime", price: 10 },
                ],
            },
        ],
    },
    birre: {
        intro: null,
        video: "social",
        groups: [
            {
                group: { it: "Alla Spina", en: "On Tap" },
                note: { it: "3 dl / 5 dl", en: "3 dl / 5 dl" },
                items: [
                    { name: "HB ORIGINAL LAGER", price: "5 / 8" },
                    { name: "HB MÜNCHEN WEISSE", price: "5 / 8" },
                    { name: "RUGENBRÄU ZWICKEL", price: "5 / 8" },
                    { name: "RUGENBRÄU AMBER", price: "5 / 8" },
                    { name: "GUINNESS", desc: "5 dl", price: 9 },
                ],
            },
            {
                group: { it: "Artigianali", en: "Craft" },
                items: [
                    { name: "BAMBA", desc: "NEIPA 6.3%", price: 8 },
                    { name: "BESTIA", desc: "IPA 6.3%", price: 8 },
                    { name: "BOMBA", desc: "Juicy Pale Ale 5.4%", price: 8 },
                    { name: "BUBBA", desc: "Double NEIPA 8.0%", price: 8 },
                    { name: "BU.FU", desc: "Triple NEIPA 9.4%", price: 9 },
                ],
            },
        ],
    },
    spirits: {
        intro: null,
        video: "social",
        groups: [
            {
                group: { it: "Gin", en: "Gin" },
                note: { it: "4,5 cl — con tonica +3.–", en: "4.5 cl — with tonic +3.–" },
                items: [
                    { name: "LONDON N.3", price: 15 },
                    { name: "SIPSMITH", price: 17 },
                    { name: "ELEPHANT", price: 16 },
                    { name: "TANQUERAY", price: 13 },
                    { name: "TANQUERAY N.10", price: 14 },
                    { name: "MARTIN MILLER'S", price: 16 },
                    { name: "MOMBASA", price: 16 },
                    { name: "MONKEY 47", price: 16 },
                    { name: "BERLINER BRANDSTIFTER", price: 16 },
                    { name: "BROCKMAN'S", price: 15 },
                    { name: "THE BOTANIST", price: 16 },
                    { name: "KNUT HANSEN", price: 17 },
                    { name: "KI NO BI", price: 17 },
                    { name: "AVIATION", price: 16 },
                    { name: "BOBBY'S", price: 17 },
                    { name: "MALFY ROSA", price: 15 },
                    { name: "CAORUNN", price: 17 },
                    { name: "ETZU", price: 17 },
                    { name: "ETZU DOUBLE YUZU", price: 17 },
                    { name: "GIN MARE", price: 15 },
                    { name: "MARE CAPRI", price: 16 },
                    { name: "NORDES", price: 15 },
                    { name: "ROKU", price: 16 },
                    { name: "NIKKA COFFEY", price: 17 },
                    { name: "CITADELLE", price: 16 },
                ],
            },
            {
                group: { it: "Vodka", en: "Vodka" },
                note: { it: "4 cl — con tonica +3.–", en: "4 cl — with tonic +3.–" },
                items: [
                    { name: "MOSKOVSKAYA", price: 12 },
                    { name: "KOSKENKORVA", price: 13 },
                    { name: "KOSKENKORVA BARREL", price: 14 },
                    { name: "BELUGA", price: 17 },
                ],
            },
            {
                group: { it: "Rum", en: "Rum" },
                note: { it: "4 cl — serviti con arancia e cioccolato fondente", en: "4 cl — served with orange and dark chocolate" },
                items: [
                    { name: "ZACAPA XO", price: 20 },
                    { name: "ZACAPA SOLERA 23", price: 18 },
                    { name: "SANTA TERESA", price: 16 },
                    { name: "DIPLOMÁTICO", price: 14 },
                ],
            },
            {
                group: { it: "Tequila & Mezcal", en: "Tequila & Mezcal" },
                note: { it: "4 cl", en: "4 cl" },
                items: [
                    { name: "PATRON SILVER", price: 15 },
                    { name: "PATRON REPOSADO", price: 16 },
                    { name: "DON JULIO REPOSADO", price: 16 },
                    { name: "DON JULIO 1942", price: 30 },
                    { name: "CLASE AZUL REPOSADO", price: 45 },
                    { name: "CASAMIGOS REPOSADO", price: 20 },
                    { name: "CASAMIGOS MEZCAL", price: 20 },
                    { name: "LA ESCONDIDA REPOSADO", price: 20 },
                    { name: "MONTELOBOS", price: 16 },
                    { name: "OJO DE TIGRE", price: 14 },
                ],
            },
            {
                group: { it: "Whisky", en: "Whisky" },
                note: { it: "4 cl", en: "4 cl" },
                items: [
                    { name: "TALISKER 10 Y.", price: 15 },
                    { name: "OBAN 14 Y.", price: 16 },
                    { name: "LAGAVULIN 16 Y.", price: 18 },
                    { name: "GLENFIDDICH PROJECT XX", price: 17 },
                    { name: "BULLEIT BOURBON", price: 16 },
                    { name: "BULLEIT 95 RYE", price: 16 },
                    { name: "NIKKA FROM THE BARREL", desc: { it: "Giappone", en: "Japan" }, price: 18 },
                ],
            },
            {
                group: { it: "Grappe", en: "Grappa" },
                note: { it: "2 cl", en: "2 cl" },
                items: [
                    { name: "MARZADRO 18 LUNE", price: 7 },
                    { name: "MARZADRO GIARE AMARONE", price: 8 },
                    { name: "MARZADRO TRENTINA BARRIQUE", price: 5 },
                    { name: "TERRENI ALLA MAGGIA BARRIQUE", price: 6 },
                ],
            },
            {
                group: { it: "Amari & Liquori", en: "Amari & Liqueurs" },
                note: { it: "4 cl", en: "4 cl" },
                items: [
                    { name: "AMARO MONTENEGRO", price: 7 },
                    { name: "BRAULIO RISERVA", price: 9 },
                    { name: "AMARO JEFFERSON", price: 9 },
                    { name: "AMARO DEL CAPO", price: 7 },
                    { name: "FERNET BRANCA", price: 7 },
                    { name: "AMARETTO DISARONNO", price: 7 },
                    { name: "LIMONCINO", price: 6 },
                ],
            },
        ],
    },
    analcolici: {
        intro: null,
        video: "social",
        groups: [
            {
                group: { it: "Mocktail", en: "Mocktails" },
                items: [
                    { name: "VIRGIN MULE", desc: "Tanqueray 0.0% · ginger beer · lime", price: 10 },
                    { name: "VIRGIN MOJITO", desc: "Lime · menta · zucchero · ginger ale", price: 13 },
                    { name: "FREE BASIL SMASH", desc: "Tanqueray 0.0% · limone · basilico", price: 13 },
                ],
            },
            {
                group: { it: "Soft Drinks", en: "Soft Drinks" },
                items: [
                    { name: "ACQUA NATURALE / FRIZZANTE", desc: "0,5 l", price: 4 },
                    { name: "COCA-COLA / ZERO", desc: "33 cl", price: 4.5 },
                    { name: "FUSE TEA PESCA / LIMONE", desc: "33 cl", price: 4.5 },
                    { name: "THREE CENTS GINGER BEER", desc: "25 cl", price: 5 },
                    { name: "THREE CENTS TONIC WATER", desc: "25 cl", price: 4.5 },
                    { name: "THREE CENTS SPARKLING LEMONADE", desc: "25 cl", price: 4.5 },
                    { name: "THREE CENTS GRAPEFRUIT SODA", desc: "25 cl", price: 4.5 },
                ],
            },
            {
                group: { it: "Zero Alcol", en: "Zero Alcohol" },
                items: [
                    { name: "HEINEKEN 0.0%", desc: "33 cl", price: 6 },
                    { name: "CRODINO", desc: "25 cl", price: 6 },
                    { name: "TANQUERAY 0.0% & TONIC", desc: "4 cl", price: 14 },
                ],
            },
        ],
    },
};

export const eventsData = [
    {
        day: { it: "Eventi", en: "Events", de: "Events", fr: "Événements" },
        title: { it: "DJ Set", en: "DJ Set", de: "DJ Set", fr: "DJ Set" },
        desc: { it: "DJ set sempre eleganti: la nota giusta per il dopocena.", en: "Always-elegant DJ sets: the right note for the late night.", de: "Stets elegante DJ-Sets: die richtige Note für die späte Nacht.", fr: "Des DJ sets toujours élégants : la note parfaite pour l'after." },
        image: "/media/dj-set.webp",
    },
    {
        day: { it: "Serata a tema", en: "Themed night", de: "Themenabend", fr: "Soirée à thème" },
        title: { it: "Ostriche & Crudi", en: "Oysters & Raw Bar", de: "Austern & Crudi", fr: "Huîtres & Crudités" },
        desc: { it: "Una notte dedicata al mare: ostriche, crudi e bollicine ghiacciate.", en: "A night dedicated to the sea: oysters, raw specialties and ice-cold bubbles.", de: "Ein Abend ganz dem Meer: Austern, Crudi und eiskalte Bubbles.", fr: "Une soirée dédiée à la mer : huîtres, crus et bulles glacées." },
        image: "/media/plateau-ostriche.jpg",
    },
    {
        day: { it: "Serata a tema", en: "Themed night", de: "Themenabend", fr: "Soirée à thème" },
        title: { it: "Pata Negra con Cortador", en: "Pata Negra with Cortador", de: "Pata Negra mit Cortador", fr: "Pata Negra avec Cortador" },
        desc: { it: "Il prosciutto spagnolo tagliato al coltello dal cortador, davanti ai tuoi occhi.", en: "Spanish ham knife-cut by the cortador, right before your eyes.", de: "Spanischer Schinken, vom Cortador direkt vor deinen Augen geschnitten.", fr: "Le jambon espagnol tranché au couteau par le cortador, sous vos yeux." },
        image: "/media/cortador-cine.png",
    },
    {
        day: { it: "Serata a tema", en: "Themed night", de: "Themenabend", fr: "Soirée à thème" },
        title: { it: "Tributi & Degustazioni", en: "Tributes & Tastings", de: "Tribute & Degustationen", fr: "Hommages & Dégustations" },
        desc: { it: "Degustazioni di vini e tributi alle regioni d'Italia, un viaggio alla volta.", en: "Wine tastings and tributes to Italy's regions, one journey at a time.", de: "Weindegustationen und Tribute an Italiens Regionen, eine Reise nach der anderen.", fr: "Dégustations de vins et hommages aux régions d'Italie, un voyage à la fois." },
        image: "/media/brindisi-gruppo.jpg",
    },
];

export const reviewsData = [
    {
        author: "Oleg Magni",
        source: "Google",
        stars: 5,
        text: {
            it: "Locale eccellente a pochi minuti a piedi dal centro di Lugano. Ambiente accogliente e moderno, perfetto per una pausa rilassante in città. Personale cordiale e attento. Consiglio vivamente di fare un salto se siete in zona!",
            en: "Excellent venue a few minutes' walk from central Lugano. Cozy, modern atmosphere, perfect for a relaxing break in the city. Friendly and attentive staff. Highly recommended if you're in the area!",
            de: "Ausgezeichnetes Lokal wenige Gehminuten vom Zentrum Luganos entfernt. Gemütliche, moderne Atmosphäre, perfekt für eine entspannte Pause. Freundliches und aufmerksames Personal. Sehr zu empfehlen!",
            fr: "Excellent lieu à quelques minutes à pied du centre de Lugano. Ambiance chaleureuse et moderne, parfaite pour une pause détente. Personnel cordial et attentif. Vraiment recommandé !",
        },
    },
    {
        author: "guglielmo pellegrini",
        source: "Google",
        stars: 5,
        text: {
            it: "Molto carino e curato, offre piatti preparati bene e con materie di buona qualità. Prezzo nella media. Consigliato.",
            en: "Very nice and well kept, well-prepared dishes made with quality ingredients. Fair price. Recommended.",
            de: "Sehr schön und gepflegt, gut zubereitete Gerichte mit hochwertigen Zutaten. Fairer Preis. Empfehlenswert.",
            fr: "Très joli et soigné, plats bien préparés avec des produits de qualité. Prix correct. Recommandé.",
        },
    },
    {
        author: "Andy",
        source: "Google",
        stars: 5,
        text: {
            it: "La pinsa è una vera libidine.",
            en: "The pinsa is pure bliss.",
            de: "Die Pinsa ist eine wahre Wonne.",
            fr: "La pinsa est un vrai délice.",
        },
    },
];
